import MyOffersLink from 'components/MyOffers/MyOffersLink/MyOffersLink';
import { withMyOffersLinkProps } from 'viewModel/myOffers/myOffersLink/withMyOffersLinkProps';

export default withMyOffersLinkProps(MyOffersLink);
